export const COLLECTION_ENGINE_USER_ID = 'a551e17e-7230-420d-b502-8fe455fa89fc';
export var UserState;
(function (UserState) {
    UserState["ACTIVE"] = "ACTIVE";
    UserState["INVITED"] = "INVITED";
    UserState["ARCHIVED"] = "ARCHIVED";
    UserState["DELETED"] = "DELETED";
})(UserState || (UserState = {}));
//# sourceMappingURL=index.js.map